function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { TextField } from '@material-ui/core';
import IconWrapper from '../../lib/IconWrapper';
import useFormHelpers from '../../hooks/useFormHelpers';

const InputFormatter = props => React.createElement(IconWrapper, {
  icon: props.icon
}, React.createElement(NumberFormat, _extends({
  customInput: TextField,
  fullWidth: true,
  inputProps: {
    inputMode: 'decimal',
    ...props.inputProps,
    'aria-label': props.label
  }
}, props)));

InputFormatter.propTypes = {
  icon: PropTypes.element,
  label: PropTypes.string.isRequired
};

const LinkedInputFormatter = ({
  getValue,
  ...props
}) => {
  const {
    onChange,
    ...helpers
  } = useFormHelpers(props, {
    getValue
  });
  return React.createElement(InputFormatter, _extends({
    onValueChange: onChange
  }, helpers));
};

LinkedInputFormatter.propTypes = {
  getValue: PropTypes.func,
  name: PropTypes.string.isRequired
};
LinkedInputFormatter.defaultProps = {
  getValue: values => values.floatValue
};

const TextFormatter = props => React.createElement(NumberFormat, _extends({
  displayType: "text"
}, props));

TextFormatter.propTypes = {
  renderText: PropTypes.func
};
TextFormatter.defaultProps = {
  renderText: value => value
};
export { InputFormatter, LinkedInputFormatter, TextFormatter };